// Below logic is based on the code here:
// https://community.shopify.com/c/Shopify-APIs-SDKs/Current-best-way-to-get-logged-in-customer-id/m-p/628513/highlight/true#M42749

import Cookies from 'js-cookie';

export class ShopifyData {
  constructor() {
    this.initialize()
    this.setCustomerToken()
    this.setCartToken()
  }

  initialize() {
    window.MakeAnOffer = window.MakeAnOffer || {}
    window.MakeAnOffer.config = window.MakeAnOffer.config || {}
  }

  setCustomerToken() {
    window.MakeAnOffer.config.customer_token = this.getCustomerToken()
  }

  setCartToken() {
    if (!!Cookies.get("mf_cart_token")) {
      window.MakeAnOffer.config.cart_token = Cookies.get("mf_cart_token");
    } else {
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          Cookies.set("mf_cart_token", data.token);
          window.MakeAnOffer.config.cart_token = data.token;

          return data;
        });
    }
  }

  getCustomerToken() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId
      if (!!curr) {
        return curr
      }
    } catch (e) { }

    try {
      let curr = window.meta.page.customerId
      if (!!curr) {
        return curr
      }
    } catch (e) { }

    try {
      let curr = _st.cid
      if (!!curr) {
        return curr
      }
    } catch (e) { }

    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken
      if (!!curr) {
        return curr
      }
    } catch (e) { }

    return null
  }
}

export default (new ShopifyData())
